import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Comprobante } from './comprobante';

@Injectable({
  providedIn: 'root'
})
export class ComprobanteService {


  constructor(private http: HttpClient) {
  }

  secuenciaComprobante(id:string,tipoDoc:string){
    
      return this.http.get<Comprobante[]>(environment.apiUrl+"/listarComprobante/?idEmisor=" +id+"&tipoDoc="+tipoDoc);  
    }

}
